import { getCurrentInstance } from "vue";
import { i as isDev } from "../utils/env.js";
import { w as warn } from "../utils/console.js";
const useDeprecatedCondition = (validators) => {
  if (!isDev) {
    return void 0;
  }
  const instance = getCurrentInstance();
  if (!instance) {
    throw new Error("`useDeprecated` hook must be used only inside of setup function!");
  }
  validators.forEach((validator) => {
    const message = validator();
    if (typeof message === "string") {
      warn(`(${instance.type.name} component) ${message}`);
    }
  });
};
export {
  useDeprecatedCondition as u
};
//# sourceMappingURL=useDeprecatedCondition.js.map
